import { Component, inject, ViewChild } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatListModule } from '@angular/material/list'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { getClient, getConciergeUser } from '@monorepo-channels/channels/domain'
import { CommonModule } from '@angular/common'
import { Router, RouterLink } from '@angular/router'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { DataLayerService } from '@monorepo-channels/shared/util-helpers'
import { MenuComponent } from '../menu/menu.component'

@Component({
	imports: [
		MatIconModule,
		MatSidenavModule,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatButtonModule,
		CommonModule,
		RouterLink,
		MenuComponent,
	],
	selector: 'feature-porto-bank-header',
	standalone: true,
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends AbstractComponent {
	public router = inject(Router)
	public client$ = this.store.select(getClient)
	public concierge$ = this.store.select(getConciergeUser)
	private dataLayerService = inject(DataLayerService)
	@ViewChild('menu') menu!: MenuComponent

	openMenu() {
		this.menu.toggle()
	}

	redirectCard() {
		this.dataLayerService.logEvent({
			event: 'button_clicked',
			screen_name: 'HEADER',
			button_name: 'PECA_SEU_CARTAO',
		})
		window.open('https://www.portoseguro.com.br/loja/cartao-de-credito/aquisicao', '_blank')
	}
}
